import React from 'react'
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { setBottomSheetPriceAndChannel } from './../app/Home'

import { setBottomSheetCheckUsername } from './../app/Home'
import { useSelector, useDispatch } from 'react-redux'
import Person from './../Public/Image/Home/Person.svg'
import PersonIcon from '@mui/icons-material/Person';
// import { Purchasememberpaypal } from './../Api/Purchasememberpaypal'
import { useLocation } from 'react-router-dom';
import cryptlib from "cryptlib"
import { setMiniLoading } from './../app/Home'
import { setIsIranian } from './../app/Home'
import { AllApi } from './../Api/AllApi'
import { GetCookie } from './../Action/GetCookie'
import { setUserFromApi } from './../app/Home'
import { SetEmail } from './../app/Slice'
// import Member from './../Public/Image/wheel/member.png'
// import { SetCookie } from './../Action/SetCookie'
import Cryptoicon from './../Public/Image/Home/cryptoicon.svg'
import CryptoDisableicon from './../Public/Image/Home/CryptoDisable.svg'
import PayPalIcon from './../Public/Image/Home/PayPalIcon.png'
import { GameDB } from '../DataBase/GameDB'
import { useHistory } from 'react-router-dom';
import { setBottomSheetsuccessfulPayment } from './../app/Home'
import { setBottomSheetUnsuccessfulPayment } from './../app/Home'

import UnsuccessfulPayment from '../BottomSheet/UnsuccessfulPayment';
import SuccessfulPayment from '../BottomSheet/SuccessfulPayment';

const ShowPriceAndChannel = () => {
    const dispatch = useDispatch()
    const BottomSheetPriceAndChannel = useSelector((state) => state.Home.BottomSheetPriceAndChannel)
    const UserNameForOrder = useSelector((state) => state.Home.UserNameForOrder)
    const location = useLocation();
    const MiniLoading = useSelector((state) => state.Home.MiniLoading)
    const UserFromApi = useSelector((state) => state.Home.UserFromApi)

    const searchParams = new URLSearchParams(location.search);

    const _id = searchParams.get('_id');
    const sku = searchParams.get('sku');
    const price = searchParams.get('Price');
    const Count = parseInt(searchParams.get('Count'));
    const Email = useSelector((state) => state.counter.email)
    const IsIranian = useSelector((state) => state.Home.IsIranian)
    const Token = GetCookie('Token')
    const [limit_cryptomus, setlimit_cryptomus] = useState(0)
    const GetProfile = async () => {
        const MakeApiClass = new AllApi();
        let AppSetting = await GameDB.AppSetting.toArray()
        if (AppSetting.length > 0) {
            setlimit_cryptomus(AppSetting[0].AppSetting.limit_cryptomus)
            // console.log(AppSetting[0].AppSetting.limit_cryptomus)
        }
        let ProfileRes = await MakeApiClass.GetProfile(Token)
        let UserPhone
        if (ProfileRes.code == 200) {
            dispatch(setUserFromApi(ProfileRes.data.user))
            if (ProfileRes.data.user) {
                // let IsIraNianForApi=false
                dispatch(SetEmail(ProfileRes.data.user.email))
                UserPhone = ProfileRes.data.user.phonenumber;
                if (UserPhone && UserPhone.length > 0 && UserPhone != undefined && UserPhone != null) {
                    UserPhone.startsWith("+98") ? dispatch(setIsIranian(true)) : dispatch(setIsIranian(false))
                    // UserPhone.startsWith("+98")?IsIraNianForApi=true:IsIraNianForApi=false

                }
            }
        }
        return UserPhone
    }
    const [MemberReward, setMemberReward] = useState(false)
    const [MemberRewardCount, setMemberRewardCount] = useState('')
    function onDismiss() {
        setTimeout(() => {
            dispatch(setBottomSheetPriceAndChannel(false))
            setMemberReward(false)
        }, 300);
    }

    const history = useHistory();


    const Pay = async () => {
        dispatch(setMiniLoading(true))
        // console.log(PaymentWay)
        // let res = await Purchasememberpaypal(Email, _id, sku, price)

        if (PaymentWay == 'Cryptomus') {
            if (CanUseWallet == true) {
                // /purchase/Crypto/getmember
                const MakeApiClass = new AllApi();

                let res = await MakeApiClass.CryptoMember(sku, UserNameForOrder, _id)
                // console.log(res) 
                if (res.code == 200) {
                    // console.log(res.code)
                    dispatch(setBottomSheetsuccessfulPayment(true))
                    dispatch(setBottomSheetPriceAndChannel(false))
                }else{
                    dispatch(setBottomSheetUnsuccessfulPayment(true));
                }
                //  
            } else {
                window.location.href = `https://api.membersgram.com/main/v1/crypto/member?data=${data}`
            }




        } else {
            if (IsIranian == false) {
                window.location.href = `https://api.membersgram.com/main/v1/webapp/purchasememberpaypal?data=${data}`
            } else if (IsIranian == true) {
                window.location.href = `https://api.membersgram.com/main/v1/webapp/zarinpal/member/gateway?data=${data}`

            }
        }




        dispatch(setMiniLoading(false))

    }
    const [CryptoDisable, setCryptoDisable] = useState(true)
    useEffect(() => {
        // console.log(Number(price))
        if (Number(price) >= limit_cryptomus) {
            // console.log('first')
            setCryptoDisable(false)

        } else {
            // console.log('123')
            setCryptoDisable(true)
        }
        if (IsIranian == undefined) {
            GetProfile()

        }
    }, [])

    const iv = '#GV^%^SUR&T*#Y*4'
    const key = cryptlib.getHashSha256('#GV^%^SUR&T*#Y*4', 32);
    const user = {
        "email": Email,
        "_id": _id, // بسته _id
        "sku": sku,
        "price": price,
        "username": UserNameForOrder,
        "phonenumber": UserFromApi.phonenumber
    }
    let data = cryptlib.encrypt(JSON.stringify(user), key, iv);

    const [PaymentWay, setPaymentWay] = useState('PayPal')




    useEffect(() => {
        GetProfileFunc()
    }, [])
    const [Data, setData] = useState('')
    const [CanUseWallet, setCanUseWallet] = useState(false)
    const GetProfileFunc = async () => {
        const Token = GetCookie('Token');

        //  let res=await GetProfile(Token)
        const MakeApiClass = new AllApi();
        let res = await MakeApiClass.GetProfile(Token)

        if (res.code == 200) {
            setData(res.data.user.walletBalance)
            let PriceNumber = Number(price)
            let wallet = Number(res.data.user.walletBalance).toFixed(2)
            // console.log(PriceNumber)
            // console.log(res.data.user.walletBalance)
            if (res.data.user.walletBalance >= PriceNumber) {
                setCanUseWallet(true)
            }
        } else if (res.code == 120 || res.code == 121 || res.code == 122 || res.code == 123) {
            let name = "Token"
            let name1 = "active"
            document.cookie = name + '=; Max-Age=-99999999;';
            document.cookie = name1 + '=; Max-Age=-99999999;';


            history.push("/");
            // dispatch(setLoading(false))

        }

    }
    // console.log(Data)
    // console.log(Count)
    return (
        <>
          <UnsuccessfulPayment />
          <SuccessfulPayment UserNameForOrder={UserNameForOrder}  Mode="member" CountCrypto={Count}/>
            <BottomSheet onDismiss={onDismiss} open={BottomSheetPriceAndChannel}>
                <div className='RegisterBeforeBottomSheet'>

                    <div className='ShowPriceAndChannelBottomSheetBody'>
                        {
                            PaymentWay == 'Cryptomus' && CanUseWallet ?
                                <div className='ShowPriceAndChannelItem'>
                                    <div className='ShowPriceAndChannelTitle'>Balance</div>
                                    <div className='ShowPriceAndChannelValue'><span className='DollarSign'>$</span> {Number(Data).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })} </div>
                                </div>
                                : 
                                  <div className='ShowPriceAndChannelItem'>
                                    <div className='ShowPriceAndChannelTitle'>&nbsp;</div>
                                    <div className='ShowPriceAndChannelValue'>&nbsp; </div>
                                </div>
                        }
                        <div className='ShowPriceAndChannelItem'>
                            <div className='ShowPriceAndChannelTitle'>Price</div>
                            <div className='ShowPriceAndChannelValue'>{IsIranian ? null : <span className='DollarSign'>$</span>}{price} {IsIranian ? "T" : null}</div>
                        </div>
                        <div className='ShowPriceAndChannelItem'>
                            <div className='ShowPriceAndChannelTitle'>Count</div>
                            <div className='ShowPriceAndChannelValue'>{Count.toLocaleString()} <PersonIcon className='PersonIcon' /></div>
                        </div>
                        <div className='ShowPriceAndChannelItem'>
                            <div className='ShowPriceAndChannelTitle'>Username</div>
                            <div className='ShowPriceAndChannelValue '>{UserNameForOrder}</div>
                        </div>
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter' >
                  
                      <div className='CryptomusAdded'>
                             { 
                        !IsIranian ? 
                        <div className='CryptomusAddedInner'>
                                {
                                    CryptoDisable ?
                                        <div onClick={() => setPaymentWay('Cryptomus')} className={PaymentWay == 'Cryptomus' ? 'CryptomusDivActive' : 'CryptomusDiv'}>
                                            {PaymentWay == 'Cryptomus' ? <img src={Cryptoicon} /> : <img src={CryptoDisableicon} />}   Crypto
                                        </div>
                                        //   <div className={'CryptomusDivDeActive'}>
                                        //     <img src={CryptoDisableicon} />   Cryptomus
                                        // </div>
                                        :
                                        <div onClick={() => setPaymentWay('Cryptomus')} className={PaymentWay == 'Cryptomus' ? 'CryptomusDivActive' : 'CryptomusDiv'}>
                                            {PaymentWay == 'Cryptomus' ? <img src={Cryptoicon} /> : <img src={CryptoDisableicon} />}   Crypto
                                        </div>
                                }

                                <div onClick={() => setPaymentWay('PayPal')} className={PaymentWay == 'PayPal' ? 'PayPalDivActive' : 'PayPalDiv'}>
                                    <img src={PayPalIcon} />  PayPal
                                </div>
                            </div>
                        :
                        null
                       } 
                            {CryptoDisable ?
                                <div className='CryptomusAddednote'>
                                    Only amounts over $1
                                </div>
                                : <div className='CryptomusAddednote'>
                                    &nbsp;
                                </div>
                                }
                            {
                                CryptoDisable && PaymentWay != 'PayPal' ?
                                    <button className='BottomSheetShowPriceAndChannelButtonDisable' style={{ 'background': '#E0E0E0', 'color': '#616161' }} >
                                        {MiniLoading ?
                                            <div className="loadminijoin"></div>
                                            :

                                            'Pay'
                                        }

                                    </button> :
                                    <button className='BottomSheetShowPriceAndChannelButton' onClick={() => Pay(data)}>
                                        {MiniLoading ?
                                            <div className="loadminijoin"></div>
                                            :

                                            'Pay'
                                        }

                                    </button>
                            }

                        </div>
                        {/* <a href={`https://api.membersgram.com/main/v1/webapp/purchasememberpaypal?data=${data}`}>
                        123
                    </a> */}
                        {/* <button className='BottomSheetCancelButton' onClick={() => dispatch(setBottomSheetCheckUsername(false))}>Cancel</button> */}

                    </div>
                </div>
            </BottomSheet>
            {/* <BottomSheet onDismiss={onDismiss} open={MemberReward}>
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className={`RegisterBeforeBottomSheetHeaderText `}>
                            <div >
                                🎉 Reward Claimed  🎉
                            </div>
                        </div>
                    </div>
                    <div className='RegisterBeforeBottomSheetBody' style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                        {MemberRewardCount} <img width={18} height={18} src={Member} style={{ margin: "0 4px 0 4px" }} />    are sending to {UserNameForOrder}
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        <button className='BottomSheetLoginButton' style={{ width: "100%" }} onClick={() => { setMemberReward(false); dispatch(setBottomSheetPriceAndChannel(false)) }}>Got it</button>
                    </div>
                </div>
            </BottomSheet> */}
        </>

    )
}

export default ShowPriceAndChannel